export const tabs = [
  { title: "Gallery", value: "1" },
];